const Microsoft = () => (
    <svg width="30px" viewBox="0 0 30 30">
        <path d="M14.3704 0H0V14.3704H14.3704V0Z" fill="#F35325" />
        <path d="M29.9973 0H15.627V14.3704H29.9973V0Z" fill="#81BC06" />
        <path d="M14.3704 15.6297H0V30.0001H14.3704V15.6297Z" fill="#05A6F0" />
        <path d="M29.9973 15.6297H15.627V30.0001H29.9973V15.6297Z" fill="#FFBA08" />
    </svg>
);

export default Microsoft;
